import { SaleBadgeProps } from '../../types';
import babaBadge from 'assets/Baba/sale-badge.png';
import { StyledBabaSaleBadge, StyledBabaSaleBadgeNumber } from './style';

export const BabaSaleBadge = ({ salePercentage }: SaleBadgeProps) => {
  return (
    <StyledBabaSaleBadge>
      <img src={babaBadge} alt="sale-badge" />
      <StyledBabaSaleBadgeNumber>
        <div>{salePercentage}%</div>
        <div>More</div>
      </StyledBabaSaleBadgeNumber>
    </StyledBabaSaleBadge>
  );
};
